import { render, staticRenderFns } from "./site-header-notifications.vue?vue&type=template&id=524b6c42&scoped=true"
import script from "./site-header-notifications.vue?vue&type=script&lang=js"
export * from "./site-header-notifications.vue?vue&type=script&lang=js"
import style0 from "./site-header-notifications.vue?vue&type=style&index=0&id=524b6c42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524b6c42",
  null
  
)

export default component.exports